import React from 'react';

import { Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';

import CopyableField from '~/components/Common/CopyableField';

import currencyFormatter from '~/utils/currencyFormatter';

import { PromoRequestLoyaltyItemExtended } from '../hooks/usePromoRequests';

const sharedOpts: Partial<GridColDef> = {
  sortable: false,
  display: 'flex',
  flex: 1,
};

const loyaltyItemCols: Array<GridColDef<PromoRequestLoyaltyItemExtended>> = [
  {
    field: 'codeName',
    headerName: 'Code Name',
    ...sharedOpts,
    minWidth: 200,
    renderCell: (params) => <Typography variant="body2">{params.row.codeName ?? '-'}</Typography>,
  },
  {
    field: 'loyaltyBonusFilterMethod',
    headerName: 'Loyalty Bonus Filter Method',
    ...sharedOpts,
    minWidth: 200,
    renderCell: (params) => <Typography variant="body2">{params.row.loyaltyBonusFilterMethod ?? '-'}</Typography>,
  },
  {
    field: 'loyaltyProductType',
    headerName: 'Product Type',
    ...sharedOpts,
    minWidth: 200,
    renderCell: (params) => <Typography variant="body2">{params.row.loyaltyProductType ?? '-'}</Typography>,
  },
  {
    field: 'resultCode',
    headerName: 'Result Code',
    ...sharedOpts,
    minWidth: 200,
    renderCell: (params) => <Typography variant="body2">{params.row.resultCode ?? '-'}</Typography>,
  },
  {
    field: 'promoKey',
    headerName: 'Promo Key',
    ...sharedOpts,
    minWidth: 200,
    renderCell: (params) => <Typography variant="body2">{params.row.promoKey ?? '-'}</Typography>,
  },
  {
    field: 'itemId',
    headerName: 'Item ID',
    ...sharedOpts,
    minWidth: 150,
    renderCell: (params) => <CopyableField value={params.row.itemId} label={params.row.itemId} />,
  },
  {
    field: 'offerId',
    headerName: 'Offer ID',
    ...sharedOpts,
    renderCell: (params) => <CopyableField value={params.row.offerId} label={params.row.offerId} />,
  },
  {
    field: 'price',
    headerName: 'Price',
    ...sharedOpts,
    minWidth: 120,
    renderCell: (params) => (
      <Typography variant="body2" fontWeight="medium">
        {currencyFormatter('AUD', params.row.price)}
      </Typography>
    ),
  },
  {
    field: 'packageId',
    headerName: 'Package ID',
    ...sharedOpts,
    renderCell: (params) => <CopyableField value={params.row.packageId} label={params.row.packageId} />,
  },
];

export { loyaltyItemCols };
